import { useIntl } from 'react-intl';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import React from 'react';
import { getCountBluecoinIdByAttached } from './BluecoinService';
import {
  bluecoinsAtom,
  isBluecoinListPanelOpenAtom,
  isBluecoinPanelOpenAtom,
} from './BluecoinState';
import useAnalytics from '../../../hooks/useAnalytics';
import { BluecoinsData } from './types';
import { autofocusAtom } from '../OnlineMapState';

interface BluecoinListPanelProps {
  map: google.maps.Map;
}

export function BluecoinListPanel(props: BluecoinListPanelProps): React.JSX.Element {
  const { formatMessage: f } = useIntl();
  const { trackEvent } = useAnalytics();
  const [isBluecoinListPanelOpen, setIsBluecoinListPanelOpen] = useRecoilState<number[] | false>(
    isBluecoinListPanelOpenAtom
  );
  const setIsBluecoinPanelOpen = useSetRecoilState<number | false>(isBluecoinPanelOpenAtom);
  const bluecoinsData = useRecoilValue<BluecoinsData>(bluecoinsAtom);
  const setAutofocus = useSetRecoilState<boolean>(autofocusAtom);

  const handleClose = (): void => {
    trackEvent(['map', 'click', 'Close bluecoin list panel']);
    setIsBluecoinPanelOpen(false);
    setIsBluecoinListPanelOpen(false);
  };

  const handleOnClickBluecoin = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    const bluecoinId = Number(event.currentTarget.id);
    setIsBluecoinPanelOpen(bluecoinId);
    trackEvent(['map', 'click', 'Select bluecoin from list', bluecoinId]);
    if (
      bluecoinsData[bluecoinId].position?.latitude &&
      bluecoinsData[bluecoinId].position?.longitude
    ) {
      const position = new google.maps.LatLng(
        bluecoinsData[bluecoinId].position.latitude,
        bluecoinsData[bluecoinId].position?.longitude
      );
      setAutofocus(false);
      const mapBounds = new google.maps.LatLngBounds();
      mapBounds.extend(position);
      props.map.fitBounds(mapBounds, { top: 50, right: 50, bottom: 100, left: 300 });
      props.map.setCenter(position);
      props.map.setZoom(20);
    }
  };

  return (
    <div className="w-map w-map--wrapper" data-cy="bluecoin-list-panel">
      <div className="w-map">
        <div className="b-widgets-info">
          <div className="b-tabs-toggler">
            <ul>
              <li className="active" key="bluecoin-list">
                <button
                  id="bluecoin-tab"
                  type="button"
                  data-cy="bluecoin-tab"
                  style={{ width: 'auto' }}
                  title={f({ id: 'table_list.tabs.bluecoin.list' })}
                >
                  {f({ id: 'bluecoins.bluecoinListPanel' })}
                </button>
              </li>

              <li className="tab-actions" />

              <li className="tab-actions">
                <button
                  type="button"
                  title={f({
                    id: 'online.panel.map.close',
                  })}
                  onClick={handleClose}
                  data-cy="close-bluecoin-list-panel"
                >
                  <i className="cmd-icon cmd-icon-remove" />
                  <span className="sr-only">{f({ id: 'online.panel.map.close' })}</span>
                </button>
              </li>
            </ul>
          </div>

          <div className="b-widgets-info-tab-content">
            <div
              style={{
                height: '232px',
                minWidth: '832px',
                minHeight: '224px',
              }}
            >
              <div
                style={{
                  zIndex: '9999',
                  width: '824px',
                  height: '224px',
                  position: 'absolute',
                  transform: 'translate(4px, 4px)',
                }}
              >
                <div data-cy="bluecoin-panel" className="ble-panel">
                  <div className="row">
                    {!isBluecoinListPanelOpen ||
                      isBluecoinListPanelOpen.map(
                        (bluecoinId, index) =>
                          index < 17 &&
                          bluecoinsData[bluecoinId] && (
                            <div
                              id={String(bluecoinsData[bluecoinId].bluecoinId)}
                              className="col-12 col-md-6 col-lg-4 mb-2"
                              title={bluecoinsData[bluecoinId].name}
                              key={`b-${bluecoinsData[bluecoinId].bluecoinId}`}
                              onClick={handleOnClickBluecoin}
                              data-cy={`bluecoin-panel-bluecoinId-${bluecoinsData[bluecoinId].bluecoinId}`}
                              style={{ cursor: 'pointer' }}
                            >
                              <i
                                data-cy="bluecoin-widget-value-size-4-row-3"
                                className="e-widget-icon cmd-icon cmd-icon-bluecoin active"
                                style={{
                                  color: `${
                                    getCountBluecoinIdByAttached(
                                      Object.values(bluecoinsData),
                                      bluecoinsData[bluecoinId].bluecoinId
                                    )
                                      ? 'rgb(123, 35, 95)'
                                      : 'rgb(73, 73, 73)'
                                  }`,
                                  fontSize: '16px',
                                  paddingRight: '5px',
                                }}
                              />
                              <span
                                style={{ marginLeft: '8px', marginTop: '4px' }}
                                data-cy={`bluecoin-panel-name-${bluecoinsData[bluecoinId].bluecoinId}`}
                              >
                                {bluecoinsData[bluecoinId].name}
                              </span>
                            </div>
                          )
                      )}

                    {isBluecoinListPanelOpen && isBluecoinListPanelOpen.length > 17 && (
                      <div>
                        <span style={{ marginLeft: '43px', marginTop: '4px' }}>
                          +{isBluecoinListPanelOpen.length - 17}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
                <span className="react-resizable-handle react-resizable-handle-se" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
